import React, { useState } from "react";
import { formatDate, validateTime } from "../../util/formatDate";
import EditAbsent from "../../component/EditAbsent";
import ButtonEdit from "../../component/ButtonEdit";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import { useDashboard } from "../../Pages/dashboard/useDashboard";
import { formatJamKerja } from "../../util/function";
import deleteIcon from "../../asset/delete_icon.png";
import { hasRole } from "../../util/function";
import "./AccordionAbsensi.css";

const STATUS_META = {
  hadir: { label: "Hadir" },
  izin: { label: "Izin" },
  sakit: { label: "Sakit" },
  alpha: { label: "Alpha" },
};

const detectStatus = (absent) => {
  const raw = (
    absent?.type ||
    absent?.absensiType ||
    absent?.requestType ||
    absent?.status ||
    absent?.keterangan ||
    ""
  )
    .toString()
    .toLowerCase();

  if (raw.includes("izin")) return "izin";
  if (raw.includes("sakit")) return "sakit";
  if (raw.includes("alpha")) return "alpha";
  return "hadir";
};

const toTimeStr = (d) =>
  d instanceof Date && !isNaN(d)
    ? `${String(d.getHours()).padStart(2, "0")}:${String(
        d.getMinutes()
      ).padStart(2, "0")}`
    : "";

const AccordionAbsensi = (props) => {
  const { data, sortedAbsent, sortedOverTime, index } = props;
  const {
    handleEdit,
    isEditAbsen,
    setIsEditAbsen,
    initialEdit,
    setInitialEdit,
    handleKirim,
    setClockInValueEdit,
    setClockOutValueEdit,
    clockInValueEdit,
    clockOutValueEdit,
    isEditOverTime,
    setIsEditOverTime,
    initialEditOT,
    setInitialEditOT,
    setDateClockOut,
    dateClockOut,
    setDateClockIn,
    dateClockIn,
    handleDeleteAbsent,
  } = useDashboard();

  const [initialExpand, setInitialExpand] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const role = localStorage.getItem("user");
  const jsonRole = JSON.parse(role);
  const canEdit = hasRole(jsonRole, "hrd_admin", "super_user");

  const startEdit = (idx, type, item, isCurrentlyEditing) => {
    handleEdit(idx, type);
    if (isCurrentlyEditing) return;

    const inDate = formatDate(item, "clockIn");
    const hasOut = item?.clockOut && item.clockOut.time !== null;
    const outDate = hasOut ? formatDate(item, "clockOut") : null;

    setDateClockIn(inDate);
    setDateClockOut(outDate || new Date());
    setClockInValueEdit(toTimeStr(inDate));
    setClockOutValueEdit(toTimeStr(outDate));
  };

  const cancelEdit = (type) => {
    if (type === "absent") {
      setInitialEdit([]);
      setIsEditAbsen(false);
    } else {
      setInitialEditOT([]);
      setIsEditOverTime(false);
    }
    setClockInValueEdit("");
    setClockOutValueEdit("");
  };

  const CancelButton = ({ type }) => (
    <button
      type="button"
      className="accordion-absensi__cancel"
      onClick={() => cancelEdit(type)}
    >
      Batal
    </button>
  );

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    await handleDeleteAbsent(deleteTarget, data.id);
    // sukses -> halaman reload otomatis; gagal -> modal ditutup lagi
    setDeleting(false);
    setDeleteTarget(null);
  };

  const editProps = {
    setClockInValueEdit,
    setClockOutValueEdit,
    clockInValue: clockInValueEdit,
    clockOutValue: clockOutValueEdit,
  };

  const renderAbsentTime = (absent, mode) => {
    const status = detectStatus(absent);
    const meta = STATUS_META[status];

    if (status !== "hadir") {
      return (
        <span
          className={`accordion-absensi__badge accordion-absensi__badge--${status}`}
        >
          {meta.label}
        </span>
      );
    }

    const isTepat = validateTime(absent, mode) === "tepat";

    return (
      <span className="accordion-absensi__time-wrap">
        <span className="accordion-absensi__badge accordion-absensi__badge--hadir">
          {meta.label}
        </span>
        <span
          className={
            isTepat
              ? "accordion-absensi__time accordion-absensi__time--ontime"
              : "accordion-absensi__time accordion-absensi__time--late"
          }
        >
          {formatDate(absent, "clockIn").toLocaleTimeString("en-GB")} -{" "}
          {absent.clockOut.time === null
            ? ""
            : formatDate(absent, "clockOut").toLocaleTimeString("en-GB")}
        </span>
      </span>
    );
  };

  const renderAbsentActions = (absent, idx) =>
    canEdit ? (
      <div className="accordion-absensi__actions">
        {isEditAbsen && initialEdit[idx] ? (
          <CancelButton type="absent" />
        ) : null}
        <ButtonEdit
          isEdit={isEditAbsen && initialEdit[idx]}
          handleKirim={() => handleKirim(absent, data.id, "absent")}
          handleEdit={() =>
            startEdit(idx, "absent", absent, isEditAbsen && initialEdit[idx])
          }
        />
        <button
          type="button"
          className="accordion-absensi__delete"
          title="Hapus absen"
          aria-label="Hapus absen"
          onClick={() => setDeleteTarget(absent)}
        >
          <img src={deleteIcon} alt="" />
        </button>
      </div>
    ) : null;
  const absentWithIdx = (sortedAbsent || []).map((absent, idx) => ({
    absent,
    idx,
  }));
  const [firstAbsent, ...restAbsent] = absentWithIdx;

  const overTimeWithIdx = (sortedOverTime || []).map((ot, idx) => ({
    ot,
    idx,
  }));
  const [firstOverTime, ...restOverTime] = overTimeWithIdx;

  const hasMoreAbsent = restAbsent.length > 0;
  const hasMoreOverTime = restOverTime.length > 0;
  const hasMore = hasMoreAbsent || hasMoreOverTime;

  return (
    <tr
      className={
        initialExpand
          ? "accordion-absensi__row accordion-absensi__row--open"
          : "accordion-absensi__row"
      }
    >
      <td className="accordion-absensi__cell accordion-absensi__cell--index">
        {index + 1}.
      </td>
      <td
        className={
          hasMore
            ? "accordion-absensi__cell accordion-absensi__cell--name"
            : "accordion-absensi__cell accordion-absensi__cell--name accordion-absensi__cell--name-static"
        }
        onClick={() => hasMore && setInitialExpand(!initialExpand)}
      >
        {hasMore ? (
          <span
            className={
              initialExpand
                ? "accordion-absensi__chevron accordion-absensi__chevron--open"
                : "accordion-absensi__chevron"
            }
          >
            ▶
          </span>
        ) : null}
        {data.name}
      </td>

      {/* Kolom Absen */}
      <td
        className="accordion-absensi__cell accordion-absensi__cell--detail"
        data-label="Absen"
      >
        {firstAbsent ? (
          <div className="accordion-absensi__entry accordion-absensi__entry--summary">
            <p className="accordion-absensi__date">
              {formatDate(firstAbsent.absent, "fullDate")} -{" "}
              {formatDate(firstAbsent.absent, "outFulldate")}
            </p>
            <div className="accordion-absensi__entry-row">
              {isEditAbsen && initialEdit[firstAbsent.idx] ? (
                <EditAbsent
                  {...editProps}
                  selected={dateClockOut}
                  selectedIn={dateClockIn}
                  onChange={(e) => setDateClockOut(e)}
                  onChangeIn={(e) => setDateClockIn(e)}
                />
              ) : (
                renderAbsentTime(firstAbsent.absent, "normalAbsent")
              )}
              {renderAbsentActions(firstAbsent.absent, firstAbsent.idx)}
            </div>
          </div>
        ) : (
          <p className="accordion-absensi__date">-</p>
        )}

        {hasMoreAbsent ? (
          <div
            className={
              initialExpand
                ? "accordion-absensi__panel accordion-absensi__panel--open"
                : "accordion-absensi__panel"
            }
          >
            <div className="accordion-absensi__panel-inner">
              <div className="accordion-absensi__list">
                {restAbsent.map(({ absent, idx }) => (
                  <div className="accordion-absensi__entry" key={idx}>
                    <p className="accordion-absensi__date">
                      {formatDate(absent, "fullDate")} -{" "}
                      {formatDate(absent, "outFulldate")}
                    </p>
                    <div className="accordion-absensi__entry-row">
                      {isEditAbsen && initialEdit[idx] ? (
                        <EditAbsent
                          {...editProps}
                          selected={dateClockOut}
                          selectedIn={dateClockIn}
                          onChange={(e) => setDateClockOut(e)}
                          onChangeIn={(e) => setDateClockIn(e)}
                        />
                      ) : (
                        renderAbsentTime(absent)
                      )}
                      {renderAbsentActions(absent, idx)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : null}
      </td>

      {/* Kolom Lembur (di mobile disembunyikan kalau kosong) */}
      <td
        className={`accordion-absensi__cell accordion-absensi__cell--detail${
          firstOverTime ? "" : " accordion-absensi__cell--empty"
        }`}
        data-label="Lembur"
      >
        {firstOverTime ? (
          <div className="accordion-absensi__entry accordion-absensi__entry--summary">
            <p className="accordion-absensi__date">
              {formatDate(firstOverTime.ot, "fullDate")}
            </p>
            <div className="accordion-absensi__entry-row">
              {isEditOverTime && initialEditOT[firstOverTime.idx] ? (
                <EditAbsent {...editProps} />
              ) : (
                <span className="accordion-absensi__time-wrap">
                  <span className="accordion-absensi__badge accordion-absensi__badge--lembur">
                    Lembur
                  </span>
                  <span className="accordion-absensi__time accordion-absensi__time--ontime">
                    {formatDate(firstOverTime.ot, "clockIn").toLocaleTimeString(
                      "en-GB"
                    )}{" "}
                    -{" "}
                    {formatDate(
                      firstOverTime.ot,
                      "clockOut"
                    ).toLocaleTimeString("en-GB")}
                  </span>
                </span>
              )}
              {canEdit ? (
                <>
                  {isEditOverTime && initialEditOT[firstOverTime.idx] ? (
                    <CancelButton type="overTime" />
                  ) : null}
                  <ButtonEdit
                    isEdit={isEditOverTime && initialEditOT[firstOverTime.idx]}
                    handleKirim={() =>
                      handleKirim(firstOverTime.ot, data.id, "overTime")
                    }
                    handleEdit={() =>
                      startEdit(
                        firstOverTime.idx,
                        "overTime",
                        firstOverTime.ot,
                        isEditOverTime && initialEditOT[firstOverTime.idx]
                      )
                    }
                  />
                </>
              ) : null}
            </div>
          </div>
        ) : (
          <p className="accordion-absensi__date">-</p>
        )}

        {hasMoreOverTime ? (
          <div
            className={
              initialExpand
                ? "accordion-absensi__panel accordion-absensi__panel--open"
                : "accordion-absensi__panel"
            }
          >
            <div className="accordion-absensi__panel-inner">
              <div className="accordion-absensi__list">
                {restOverTime.map(({ ot, idx }) => (
                  <div className="accordion-absensi__entry" key={idx}>
                    <p className="accordion-absensi__date">
                      {formatDate(ot, "fullDate")}
                    </p>
                    <div className="accordion-absensi__entry-row">
                      {isEditOverTime && initialEditOT[idx] ? (
                        <EditAbsent {...editProps} />
                      ) : (
                        <span className="accordion-absensi__time-wrap">
                          <span className="accordion-absensi__badge accordion-absensi__badge--lembur">
                            Lembur
                          </span>
                          <span className="accordion-absensi__time accordion-absensi__time--ontime">
                            {formatDate(ot, "clockIn").toLocaleTimeString(
                              "en-GB"
                            )}{" "}
                            -{" "}
                            {formatDate(ot, "clockOut").toLocaleTimeString(
                              "en-GB"
                            )}
                          </span>
                        </span>
                      )}
                      {canEdit ? (
                        <>
                          {isEditOverTime && initialEditOT[idx] ? (
                            <CancelButton type="overTime" />
                          ) : null}
                          <ButtonEdit
                            isEdit={isEditOverTime && initialEditOT[idx]}
                            handleKirim={() =>
                              handleKirim(ot, data.id, "overTime")
                            }
                            handleEdit={() =>
                              startEdit(
                                idx,
                                "overTime",
                                ot,
                                isEditOverTime && initialEditOT[idx]
                              )
                            }
                          />
                        </>
                      ) : null}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : null}
      </td>

      <td className="accordion-absensi__cell accordion-absensi__cell--jamlebih">
        {data.jamLebih && data.jamLebih !== 0
          ? `${formatJamKerja(data.jamLebih)} Jam`
          : "-"}

        {/* Modal pakai portal ke document.body, jadi aman ditaruh di dalam <td> */}
        <ConfirmModal
          open={!!deleteTarget}
          title="Hapus data absen?"
          loading={deleting}
          onConfirm={confirmDelete}
          onCancel={() => setDeleteTarget(null)}
        >
          Data absen berikut akan dihapus permanen dan tidak bisa dikembalikan.
          {deleteTarget ? (
            <div className="cm-detail">
              <b>{data.name}</b>
              <span>
                {deleteTarget.clockIn.day} · {deleteTarget.clockIn.time}
                {deleteTarget.clockOut?.time
                  ? ` - ${deleteTarget.clockOut.time}`
                  : ""}
              </span>
            </div>
          ) : null}
        </ConfirmModal>
      </td>
    </tr>
  );
};
export default AccordionAbsensi;
